import { gql } from '@apollo/client';

export const CalendarEventFields = gql`
  fragment CalendarEventFields on Event {
    id
    name
    startDate
    endDate
    recurring
    notes
    createdAt
    updatedAt
    calendarResource {
      id
      name
      jobType {
        id
        name
      }
      trade {
        id
        name
      }
    }
  }
`;
